/**
 *
 * InfoCard
 *
 */

import React, { memo } from 'react';
import classNames from 'classnames';
import { useTranslation } from "react-i18next";

// styles
import './style.scss';

// antd component
import { Card } from 'antd';
//const { Meta } = Card;

function InfoCard({
  title,
  // actions
  editACtion,
  // default
  children,
  className,
  ...rest
}) {
  const childClassNames = classNames('details-card', className);
  const { t } = useTranslation();

  return (
    title && (
      <Card
        className={childClassNames}
        title={title}
        bordered={false}
        extra={
          !!editACtion && (
            <span onClick={editACtion} className='details-card__action'>
              {t('common.modify')}
            </span>
          )
        }
        {...rest}
      >
        {children || '--'}
      </Card>
    )
  );
}

export default memo(InfoCard);
